export default {
  type: "button",
  data: {
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 24,
    paddingRight: 24,
    html: "Add button text",
    align: "center",
    autoWidth: true,
    target: true,
    linkNewTab: true,
    linkUrlType: "web",
    backgroundColor: { r: 0, g: 0, b: 0, a: 1 },
    color: { r: 255, g: 255, b: 255, a: 1 },
    linkUrl: "https://www.radicasys.com",
  },
  children: [],
};
